const convertedDate = (date: string): Date => {
  const d = new Date(date);
  d.setTime(d.getTime() + d.getTimezoneOffset() * 60 * 1000);
  return d;
};

const convertedDateDisplay = (date: string): string | null => {
  if (date) {
    const d = new Date(date);
    d.setTime(d.getTime() + d.getTimezoneOffset() * 60 * 1000);
    return d.toLocaleDateString('fr-CA');
  }
  return null;
};

const toUtcDateOnly = (date: string): Date => {
  const d = new Date(date);
  return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
};

export { convertedDate, convertedDateDisplay, toUtcDateOnly };
